import sect1_left from '../../../assets/images/s2_1_1_sect1_left.png';
import sect1_right from '../../../assets/images/s2_1_1_sect1_right.png';

export default function GoContact({}) {
  return (
    <>
      <div className="gotoContact pt-10">
        <div className="txt-center mb-4">
          <p className="prt-medium fs-22 fc-005eed  mb-1">크림봇</p>
          <p className="prt-bold fs-40 fc-black1 lh-13">서비스 로봇의 혁신</p>
        </div>
        <div className="center">
          <div className="row-flex-center between m-col-flex t-col-flex">
            <div className="s2_1_1_left relative w-48 m-w-100 m-mb-20 t-w-100 t-mb-20">
              <img src={sect1_left} alt="" />
              <div className="s2_1_1_left_inner absolute">
                <p className="prt-regular fs-18 fc-4b mb-2">매출 상승 지름길</p>
                <p className="prt-bold fs-30 fc-black1 mb-10 lh-14">
                  합리적인 가격으로
                  <br />
                  <span className="fc-005eed">크림봇</span>을 만나보세요
                </p>
                <a
                  href="/sub5_1"
                  className="gotoContact_btn w-fitcontent prt-medium fs-16 fc-black1"
                >
                  제휴문의
                </a>
              </div>
            </div>

            <div className="s2_1_1_right relative w-48 m-w-100 t-w-100 ">
              <img src={sect1_right} alt="" />
              <div className="s2_1_1_left_inner absolute">
                <p className="prt-regular fs-18 fc-a5 mb-2">
                  사장님의 현명한 선택
                </p>
                <p className="prt-bold fs-30 fc-white mb-10 lh-14">
                  크림봇 고객분들의 <br />
                  <span className="fc-52e3cd">실사용 후기</span>
                </p>
                <a
                  href="/sub4_1"
                  className="gotoContact_btn2 w-fitcontent fc-white prt-medium fs-16"
                >
                  설치사례
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
